import { useComboBoxStore } from '../store';

export const useComboboxIsOpen = (): boolean => useComboBoxStore((state) => !!state.targetRange);
